<template>
    <div class="body back-gray">
        <div class="wrap end txt-center">
            <p class="bold font-20">
                응시를 시작합니다.
            </p>
            <p class="font-16 mt-20">
                재응시는 불가하니<br>시작 후 응시를 끝까지 완료해주세요.
            </p>
        </div>
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="start()">응시하기</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'TestStart',
    components: {
        Footer
    },
    data: () => ({
        type:""
    }),
    mounted() {
       this.type = this.$route.params.type;
    },
    methods: {  
        start(){
//             1. idx  (student idx)
//  2. status
            var params = {
                idx:sessionStorage.getItem("student_idx"),
                status:"PROCCESS"
            }
            this.axios.post(this.axios.root + "/rest/access/getStartExam",params).then(res =>{
                if(res.data.err == 0){
                    this.$router.push('/part01/'+this.type);
                }else{
                    alert(res.data.err_msg);
                    this.$route.push("/intro");
                }
            });
            
        }

    }
}
</script>